import React, { Component } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown
} from "reactstrap";
import { MdAccountCircle } from "react-icons/md";
import { MdDashboard } from "react-icons/md";
import jwt_decode from "jwt-decode";

class Header extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
      userLogged: ""
    };
  }

  componentDidMount() {
    if (localStorage.getItem("token") !== null) {
      const userToken = JSON.parse(localStorage.getItem("token").toString());
      let decoded = jwt_decode(userToken.token);
      let userNameFormat = decoded.usuario.toUpperCase().split(".");
      this.setState({
        userLogged: userNameFormat[1]
          ? userNameFormat[0] + " " + userNameFormat[1]
          : userNameFormat[0]
      });
    } else this.setState({ userLogged: "" });
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  logout = () => {
    if (localStorage.getItem("token") !== null) {
      const userToken = JSON.parse(localStorage.getItem("token").toString());
      let decoded = jwt_decode(userToken.token);
      fetch(`https://appv1.all.com.br/logout`, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id_usuario: decoded.id,
          token: userToken.token
        })
      }).then(response => {
        if (response.status === 200) {
          localStorage.clear();
          window.location.href = "/logout";
        }
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <div className="header-content">
          <div
            className="navbar-fixed"
            style={{
              minWidth: "50%",
              maxWidth: "100%",
              margin: "auto"
            }}
          >
            <nav>
              <div
                className="nav-wrapper"
                style={{
                  backgroundColor: "#357ae8",
                  width: "100%",
                  boxShadow:
                    "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)"
                }}
              >
                <ul>
                  <p
                    onClick={() => (window.location.href = "/painel")}
                    className="brand-logo"
                    style={{ fontStyle: "bold", fontSize: "1.8rem" }}
                    title="Voltar ao painel principal."
                  >
                    <MdDashboard className="icon-dash" />
                    {this.props.title && this.props.title}
                  </p>
                </ul>
                <ul className="right brand-logo">
                  <UncontrolledDropdown>
                    <Dropdown
                      setActiveFromChild
                      isOpen={this.state.dropdownOpen}
                      toggle={this.toggle}
                    >
                      <DropdownToggle className="toggle">
                        <div alt="user" className="circle user-img">
                          <i className="user">
                            <MdAccountCircle />
                          </i>
                        </div>
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem header>USUÁRIO</DropdownItem>
                        {this.state.userLogged !== "" && (
                          <DropdownItem>{this.state.userLogged}</DropdownItem>
                        )}
                        <DropdownItem divider />
                        <DropdownItem
                          tag="a"
                          active
                          onClick={() => this.logout()}
                        >
                          SAIR
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </UncontrolledDropdown>
                </ul>
              </div>
              <div
                className="nav-content"
                style={{
                  width: "99.8%",
                  margin: "auto",
                  float: "center",
                  display: "block",
                  boxShadow:
                    "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)"
                }}
                hidden={
                  !this.props.activeNavContent
                    ? this.props.activeNavContent
                    : true
                }
              >
                <ul className="tabs">
                  <li className="tab">
                    <a
                      className="active"
                      href="#recent"
                      onClick={() => this.props.activeChoose("recent")}
                    >
                      Atuais
                    </a>
                  </li>
                  <li className="tab">
                    <a
                      href="#old"
                      onClick={() => this.props.activeChoose("old")}
                    >
                      Antigos
                    </a>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Header;
